import { render, staticRenderFns } from "./changeProductDescriptionTo.vue?vue&type=template&id=68ce6444&"
import script from "./changeProductDescriptionTo.vue?vue&type=script&lang=js&"
export * from "./changeProductDescriptionTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports